import { Fragment } from 'react'

import { ArticleListItem } from '~/shared/components/Articles/ArticlesList/ArticlesList.types'

import VerticalArticleItem from './VerticalArticleItem'

export default function VerticalArticleGroup({
  articles,
  className = '',
}: {
  articles: ArticleListItem[]
  className?: string
}): React.ReactElement {
  return (
    <div className={`${className}`}>
      {articles.map(({ _id, slug, ...rest }, index) => (
        <Fragment key={_id}>
          <VerticalArticleItem slug={slug.current} {...rest} />

          <div className={index !== articles.length - 1 ? 'block' : 'hidden'}>
            <hr className="my-6 border-t border-gray-light" />
          </div>
        </Fragment>
      ))}
    </div>
  )
}
